import { defineStore } from "pinia";
import { api } from "@/shared/resource/apis/baseApi";
import { SYSTERM_SETTINGS } from "@/shared/resource/apis/endpoints";

export const useSiteSettingsStore = defineStore("siteSettings", {
  state: () => ({
      siteSettings: [],
      siteSetting: null,
  }),
  actions: {
    async addSiteSetting(setting) {
      const response = await api.post(SYSTERM_SETTINGS.POST, setting);
      return response.data;
    },
    async getSiteSetting({ page = 1, limit = 10,filters={} }){
      const response = await api.get(SYSTERM_SETTINGS.GET,{params: { page_no: page, limit,...filters }})
      this.siteSettings = response.data.data || [];
      return response.data
    },
    async deleteSiteSetting(key) {
      const response = await api.delete(SYSTERM_SETTINGS.DELETE(key));
      return response.data;
    },
    async fetchSiteSetting(key){
      const response = await api.get(SYSTERM_SETTINGS.GET_BY_ID(key));
      this.siteSetting = response.data.data || null;
      return response.data
    },
    async updateSetting(key, payload) {
      const response = await api.put(SYSTERM_SETTINGS.UPDATE(key), payload);
      return response.data;
    },
    resetSiteSettingData(){
      this.siteSetting = null
    }
  },
  getters: {
    getSiteSettings: (state) => state.siteSettings,
    getSelectedSiteSetting: (state) => state.siteSetting,
  },
});
